/* globals jQuery */
//https://swiperjs.com/
import Swiper from 'swiper';
import {Autoplay, Navigation, Pagination, EffectFade, A11y, FreeMode,Thumbs} from 'swiper/modules';

(($) => {

    //homepage community slider
    const commSlider = new Swiper('.js-com-carousel', {
        modules: [Navigation,Pagination,A11y],
        slidesPerView: "auto",
        spaceBetween: 0,
        pagination: {
            el: ".swiper-pagination",
            type: "progressbar",
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    //community-landing hero slider
    const comLandingHero = new Swiper('.box-slider', {
        modules: [EffectFade,Pagination,A11y,Autoplay],
        loop: false,
        fadeEffect: { crossFade: true },
        effect: 'fade',
        autoplay: {
            delay: 4000
        },
        pagination: {
            el: '.box-slider-pagination',
            clickable: true
        },
    });

    // //INTERIOR GALLERY w/ THUMBNAILS
    const galleries = document.querySelectorAll('.gallery');
    const galleryPrev = document.querySelectorAll('.gallery-prev');
    const galleryNext = document.querySelectorAll('.gallery-next');

    galleries.forEach((gallery, index) => {

        let slider = gallery.querySelector('.js-gallery-slides');
        let thumbs = gallery.querySelector('.js-gallery-thumbs');

        const galleryThumbs = new Swiper(thumbs, {
            modules: [FreeMode,A11y],
            spaceBetween: 16,
            slidesPerView: 'auto',
            loop: false,
            freeMode: true
        });

        const galleryTop = new Swiper(slider, {
            modules: [EffectFade,Navigation,Pagination,A11y,Thumbs],
            loop: false,
            fadeEffect: { crossFade: true },
            effect: 'fade',
            navigation: {
                prevEl: galleryPrev[index],
                nextEl: galleryNext[index]
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });

    });


    // FEATURE CAROUSEL
    const featureSwipers = document.querySelectorAll('.feature-swiper');
    const carouselPrev = document.querySelectorAll('.feature-swiper__prev');
    const carouselNext = document.querySelectorAll('.feature-swiper__next');
    const carouselPag = document.querySelectorAll('.feature-swiper__pagination');

    featureSwipers.forEach((carousel, index) => {

        let carouselSlider = carousel.querySelector('.js-carousel-slides');
        let carouselLength = carousel.querySelectorAll('.swiper-slide').length;
        console.log(carouselLength);

        const featureSlider = new Swiper(carouselSlider, {
            modules: [Navigation,Pagination,A11y],
            loop: false,
            initialSlide: carouselLength > 2 ? 1 : 0,
            pagination: {
                el: carouselPag[index],
                type: "fraction",
                formatFractionCurrent: function (number) {
                    return ('0' + number).slice(-2);
                },
                formatFractionTotal: function (number) {
                    return ('0' + number).slice(-2);
                },
            },
            navigation: {
                prevEl: carouselPrev[index],
                nextEl: carouselNext[index]
            },
            on: {
                init: function () {
                    console.log(this.slides.length);
                },
            },
        });

    });


    // FEATURE CAROUSEL
    const awardsSwipers = document.querySelectorAll('.awards-swiper');
    const awardsPag = document.querySelectorAll('.awards-swiper__pagination');

    awardsSwipers.forEach((awards, index) => {

        let awardsSlider = awards.querySelector('.js-awards-swiper');

        const awardsList = new Swiper(awardsSlider, {
            modules: [Pagination,A11y,FreeMode],
            slidesPerView: 2,
            spaceBetween: 20,
            centerInsufficientSlides: true,
            freeMode: true,
            watchSlidesProgress: true,
            pagination: {
                el: awardsPag[index],
                clickable: true
            },
            breakpoints: {
                650: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                768: {
                    slidesPerView: 4,
                    spaceBetween: 40,
                },
                1024: {
                    slidesPerView: 6,
                    spaceBetween: 50,
                }

            }
        });
    });
    
    const testimonialSwipers = document.querySelectorAll('.testimonial-slideshow');
    const testimonialPag = document.querySelectorAll('.testimonial__pagination');

    testimonialSwipers.forEach((test, index) => {

        let testSlider = test.querySelector('.js-testimonial-swiper');

        const testList = new Swiper(testSlider, {
            modules: [EffectFade,Pagination,A11y,Thumbs,Autoplay],
            loop: true,
            fadeEffect: { crossFade: true },
            effect: 'fade',
            autoplay: {
                delay: 10000
            },
            pagination: {
                el: testimonialPag[index],
                clickable: true
            }
        });
    });

})(jQuery)